export default __webpack_public_path__ + "static/media/radar.c81529c7.svg";